<template>
    <div>
        <el-form label-position="left" label-width="60px">
            <el-row :gutter="10">
                <el-col :span="20">
                    <el-form-item label="商品名">
                        <el-input v-model="$parentInfo.update_goods.good.name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="20">
                    <el-form-item label="价格">
                        <el-input v-model="$parentInfo.update_goods.good.price"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="20">
                    <el-form-item label="数量">
                        <el-input v-model="$parentInfo.update_goods.good.amount" type="number"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div class="m-portlet__foot">
            <div style="text-align: right">
                <el-button @click="handleStoreGood" :loading="$parentInfo.store_goods.button_loading">创建</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_CreateGoods",
        data() {
            return {

            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowGood();
        },
        methods: {
            handleShowGood(){
                this.$wApi.send(this.$parentInfo.path, 'show_goods', {'good_id':this.$store.state.modal.data.good_id});
            },
            handleStoreGood(){
                this.$parentInfo.store_goods.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'update_goods', {'filter':this.$parentInfo.update_goods.good});
            }
        }
    }
</script>

<style scoped>

</style>